import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import logoImage from "../../assets/images/logo.png";
import { userLoggedOut } from "../../features/auth/authSlice";
import gravatarUrl from "gravatar-url";
import { useState } from "react";
import Search from "./Search";

export default function Navigation({ project = false }) {
    const dispatch = useDispatch();
    const [menuOpen, setMenuOpen] = useState(false);
    const [profileOpen, setProfileOpen] = useState(false);

    const { user } = useSelector((state) => state.auth);
    const { email, name } = user || {};

    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };
    return (
        <>
            {/* <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-slate-900 bg-opacity-75"> */}
            <nav className=" border-gray-200 px-2 sm:px-4 py-2.5 bg-gray-900">
                <div className="container flex flex-wrap justify-between items-center mx-auto">
                    <Link to="/projects" className="flex items-center">
                        <img src={logoImage} className="h-12 " alt="" />
                    </Link>
                    <div className="flex items-center md:order-2 ml-auto">
                        <button
                            type="button"
                            className="flex mr-3 text-sm bg-gray-800 rounded-full md:mr-0 focus:ring-4 focus:ring-gray-600"
                            id="user-menu-button"
                            aria-expanded="false"
                            data-dropdown-toggle="user-dropdown"
                            data-dropdown-placement="bottom"
                            onClick={(e) => setProfileOpen(!profileOpen)}
                        >
                            <span className="sr-only">Open user menu</span>
                            <img
                                className="w-8 h-8 rounded-full"
                                src={gravatarUrl(email, {
                                    size: 80,
                                })}
                                alt={name}
                            />
                        </button>
                        {/* Dropdown menu */}
                        <div
                            className={`${
                                profileOpen ? "block" : "hidden"
                            } z-50 my-4 text-base list-none bg-gray-800 rounded divide-y divide-gray-100 shadow`}
                            id="user-dropdown"
                            style={{
                                position: "absolute",
                                // inset: "0px auto auto 0px",
                                // margin: 0,
                                // transform: "translate(0px, 70px)",
                                right: "45px",
                                top: "45px",
                            }}
                            data-popper-reference-hidden
                            data-popper-escaped
                            data-popper-placement="top"
                        >
                            <div className="py-3 px-4">
                                <span className="block text-sm text-white">
                                    {name}
                                </span>
                                <span className="block text-sm font-medium truncate text-gray-400">
                                    {email}
                                </span>
                            </div>
                            <ul
                                className="py-1"
                                aria-labelledby="user-menu-button"
                            >
                                <li>
                                    <span
                                        onClick={logout}
                                        className="cursor-pointer block py-2 px-4 text-sm hover:bg-gray-600 text-gray-200 hover:text-white"
                                    >
                                        Sign out
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <button
                            data-collapse-toggle="mobile-menu-2"
                            type="button"
                            className="inline-flex items-center p-2 ml-1 text-sm text-gray-400 rounded-lg md:hidden hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
                            aria-controls="mobile-menu-2"
                            aria-expanded="false"
                            onClick={(e) => setMenuOpen(!menuOpen)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <svg
                                className="w-6 h-6"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>
                    </div>
                    <div
                        className={`${
                            menuOpen ? "block" : "hidden"
                        } justify-between items-center w-full md:flex md:w-auto md:order-1 md:ml-10`}
                        id="mobile-menu-2"
                    >
                        {project && <Search />}
                        <ul className="flex flex-col p-4 mt-4 rounded-lg border md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 bg-gray-800 md:bg-gray-900 border-gray-700">
                            <li>
                                <NavLink
                                    to="/projects"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "block py-2 pr-4 pl-3 text-white bg-green-700 rounded md:bg-transparent md:text-green-400 md:p-0"
                                            : "block py-2 pr-4 pl-3 rounded md:hover:bg-transparent md:p-0 text-gray-400 md:text-white hover:bg-gray-700 hover:text-white border-gray-700"
                                    }
                                    // aria-current="page"
                                >
                                    PROJECTS
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/teams"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "block py-2 pr-4 pl-3 text-white bg-green-700 rounded md:bg-transparent md:text-green-400 md:p-0"
                                            : "block py-2 pr-4 pl-3 rounded md:hover:bg-transparent md:p-0 text-gray-400 md:text-white hover:bg-gray-700 hover:text-white border-gray-700"
                                    }
                                >
                                    TEAMS
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            {/* <img src={logoImage} className="h-10 " alt="" />
            {project && (
                <input
                    className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
                    type="search"
                    placeholder="Search for anything…"
                />
            )}
            <div className="ml-10">
                <Link
                    className="mx-2 text-sm font-semibold text-green-300"
                    to="/projects"
                >
                    Projects
                </Link>
                <Link
                    className="mx-2 text-sm font-semibold text-white hover:text-green-300"
                    to="/teams"
                >
                    Team
                </Link>
            </div>
            <div className="ml-auto flex items-center justify-center">
                <button className="flex items-center justify-center w-8 h-8 overflow-hidden rounded-full">
                    <img
                        src={gravatarUrl(email, {
                            size: 80,
                        })}
                        alt={name}
                    />
                </button>
                <span className="ml-3 text-white">{name}</span>
                <button
                    className="ml-3 text-white cursor-pointer p-3 py-1 bg-slate-800 rounded-full shadow-lg hover:bg-slate-900"
                    onClick={logout}
                >
                    Log out
                </button>
            </div> */}

            {/* </div> */}
        </>
    );
}
